import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'ble_devices',
  title: 'Реестр идентификаторов BLE-меток',
  apiType: apiTypes.ALT_NAV_API,
  elemsOnPage: 100,
  connections: {
    bledevicestype: {
      apiType: apiTypes.ALT_NAV_API,
      table: 'ble_devices_type',
      fields: ['name_type'],
      format: (elem: any) => elem['name_type'],
      index: 'id',
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'serial_number',
      title: 'Заводской серийный номер',
      type: 'text',
      required: true,
    },
    {
      name: 'R0_serial_number',
      title: 'Подменный серийный номер (R0)',
      type: 'text',
      required: true,
    },
    {
      name: 'device_type_id',
      title: 'Тип',
      type: 'number',
      required: true,
      connection: 'bledevicestype',
    },
  ],
  newTemplate: {
    serial_number: '',
    R0_serial_number: '',
    device_type_id: null,
  },
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'id',
        field: 'id'
      },
      {
        title: 'serial_number',
        field: 'serial_number'
      },
      {
        title: 'R0_serial_number',
        field: 'R0_serial_number'
      },
      {
        title: 'device_type_id',
        field: 'device_type_id'
      },
    ],
    example: `1;234;1234;1`
  }
};

export default config;